export enum ErrorResponseCode {
  NOT_FOUND = 404,
  UNAUTHORIZED = 401,
  INVALID = 422,
  EXCEPTION = 500
}
